import { render, staticRenderFns } from "./homeBanner.vue?vue&type=template&id=2327342e&scoped=true"
import script from "./homeBanner.vue?vue&type=script&lang=js"
export * from "./homeBanner.vue?vue&type=script&lang=js"
import style0 from "./homeBanner.vue?vue&type=style&index=0&id=2327342e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2327342e",
  null
  
)

export default component.exports